var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGpsTrack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-gps-track"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "gps-track",
    clipPath: "url(#clip-gps-track)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748",
    transform: "translate(-83 -317.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "placeholder",
    transform: "translate(91.587 319)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4750",
    "data-name": "Group 4750",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17331",
    "data-name": "Path 17331",
    d: "M87.314,0a11.316,11.316,0,0,0-9.625,17.264L86.67,31.737a.943.943,0,0,0,.8.446h.007a.943.943,0,0,0,.8-.458l8.752-14.614A11.317,11.317,0,0,0,87.314,0Zm8.1,16.143L87.457,29.429,79.292,16.27a9.435,9.435,0,1,1,16.123-.127Z",
    transform: "translate(-76)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4752",
    "data-name": "Group 4752",
    transform: "translate(5.657 5.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4751",
    "data-name": "Group 4751",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17332",
    "data-name": "Path 17332",
    d: "M171.657,90a5.657,5.657,0,1,0,5.657,5.657A5.664,5.664,0,0,0,171.657,90Zm0,9.441a3.784,3.784,0,1,1,3.778-3.784A3.787,3.787,0,0,1,171.657,99.441Z",
    transform: "translate(-166 -90)",
    fill: "#5c6d7e",
    stroke: "#5c6d7e",
    strokeWidth: 0.2
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17336",
    "data-name": "Path 17336",
    d: "M-13601.235-17906.5h-7.967l-3.044,12.488h30.806l-3.375-12.406-.023-.082h-8.257",
    transform: "translate(13699.999 18250.238)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpsTrack);
export default __webpack_public_path__ + "static/media/gps-track.5373aeb499c3d8aa74ccae09de9b3b13.svg";
export { ForwardRef as ReactComponent };